export default __webpack_public_path__ + "static/media/bg1111.ca95d177.png";